"use client";

import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@tillix/ui-atoms/atoms/collapsible";
import { CheckCircle2Icon, ChevronDownIcon } from "lucide-react";
import type { NigoFlags } from "./types";

const FLAG_LABELS: { key: keyof NigoFlags; label: string }[] = [
  { key: "missingSSN", label: "Social Security Number" },
  { key: "missingAddress", label: "Mailing Address" },
  { key: "missingACH", label: "Bank Account Information" },
  { key: "missingDocs", label: "Supporting Documents" },
];

interface NigoSummaryProps {
  flags: NigoFlags;
  completed?: boolean;
}

export default function NigoSummary({ flags, completed }: NigoSummaryProps) {
  const missingItems = FLAG_LABELS.filter((f) => flags[f.key]);

  if (missingItems.length === 0) return null;

  return (
    <Collapsible defaultOpen={!completed}>
      <CollapsibleTrigger className="group flex w-full items-center gap-2 text-muted-foreground text-sm transition-colors hover:text-foreground">
        {completed ? (
          <CheckCircle2Icon className="size-4 text-green-600" />
        ) : (
          <ChevronDownIcon className="size-4 -rotate-90 transition-transform duration-200 group-data-[panel-open]:rotate-0" />
        )}
        <span className={completed ? "text-green-600" : undefined}>
          {completed
            ? `${missingItems.length} completed ${missingItems.length === 1 ? "item" : "items"}`
            : `${missingItems.length} missing ${missingItems.length === 1 ? "item" : "items"} to resolve`}
        </span>
      </CollapsibleTrigger>
      <CollapsibleContent>
        <ul className="mt-2 flex flex-col gap-1 pl-6 text-muted-foreground text-sm">
          {missingItems.map((item) => (
            <li className="flex items-center gap-2" key={item.key}>
              <span
                className={`size-1.5 rounded-full ${completed ? "bg-green-500" : "bg-amber-500"}`}
              />
              {item.label}
            </li>
          ))}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
}
